import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  SetUserImageRequest,
  SetUserImageResponse,
  UpdateUserInfoRequest,
  UpdateUserInfoResponse,
} from "../../models/User.model";
import { environment } from "../../environments";
import axios from "axios";
const API_BASE_URL = environment.apiUrl;

export const setUserImage = createAsyncThunk<
  SetUserImageResponse,
  SetUserImageRequest,
  { rejectValue: string }
>("user/setUserImage", async (request, { rejectWithValue }) => {
  try {
    const response = await axios.post<SetUserImageResponse>(
      `${API_BASE_URL}Users/SetUserImage`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.data.success) {
      return rejectWithValue(response.data.message);
    }

    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      return rejectWithValue(error.response.data.message);
    }
    return rejectWithValue("שגיאה בטעינת משתמשי החברה");
  }
});

export const updateUserInfo = createAsyncThunk<
  UpdateUserInfoResponse,
  UpdateUserInfoRequest,
  { rejectValue: string }
>("user/updateUserInfo", async (request, { rejectWithValue }) => {
  try {
    const response = await axios.post<UpdateUserInfoResponse>(
      `${API_BASE_URL}Users/UpdateUserInfo`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.data.success) {
      return rejectWithValue(response.data.message);
    }

    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      return rejectWithValue(error.response.data.message);
    }
    return rejectWithValue("שגיאה בעדכון פרטי המשתמש");
  }
});
